import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { PERMISSION_KEYS } from '../config/permissions'
import { loadingClass } from '../lib/ui'

/** Доступ к разделу «Заявки на производство». */
export function RequireProductionRequestsAccess({ children }: { children: ReactNode }) {
  const { can, loading } = useAuth()

  if (loading) {
    return (
      <div className={loadingClass}>
        <p>Загрузка…</p>
      </div>
    )
  }

  if (!can(PERMISSION_KEYS.PRODUCTION_REQUESTS_READ)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
